export const AUTH_BANNER_SHOW = "AUTH_BANNER_SHOW";
export const AUTH_BANNER_CLEAR = "AUTH_BANNER_CLEAR";
